import { render } from "./HeroiconsSolidScale.vue?vue&type=template&id=4a717a33"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidScale.vue"]])

export default __exports__